import React from 'react';

import css from 'styles/components/common/singleStarRating.scss';

const SingleStarRating = ({ rating, ratingCount }) => {
  if (!rating) {
    return null;
  }
  return (
    <>
      <dt>Rating</dt>
      <dd
        className={css.rating}
        itemProp="aggregateRating"
        itemScope
        itemType="http://schema.org/AggregateRating">
        <meta itemProp="reviewCount" content={ratingCount}/>
        <meta itemProp="ratingValue" content={rating}/>
        {rating}
      </dd>
    </>
  );
};

export default SingleStarRating;
